import React, { useRef} from 'react'

import ColAtm from "../../../../atomic/Col/Col";

import LabelAtm from "../../../../atomic/Label/Label";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import { withStyles} from "@material-ui/core/styles";
import {useForm} from "react-hook-form";
import PasswordInput from "../../../../molecules/PasswordInput/PasswordInput";

const styles = theme => ({
    body: {
        background: '#ffffff'
    },
    root: {
        margin: 'auto',
    },
    restrictInfo: {
        paddingTop: '24px'
    },
    eye: {
        cursor: 'pointer',
    },
});

const ResetPasswordForm = (props) => {

    const { register, handleSubmit, errors ,watch} = useForm({
        mode: "onChange",
        reValidateMode: 'onChange',
    });

    const password = useRef({});
    password.current = watch("password", "");

    const onSubmit = (data) => {

        const params = {
            email : props.email,
            key : props.hash,
            password : data.password,
            password_confirmation :data.password_confirmation
        }

        props.resetPassword(params)
    }


    return (
        <>
            <ColAtm container className={props.classes.root}  direction="row" md={6}>
                <form onSubmit={handleSubmit(onSubmit)} className="edit-profile-form" name="general-form" id="general-form" >
                <LabelAtm variant="h6" component="h2" text="Reset Password" />

                    <PasswordInput
                        name="password"
                        label="Yeni Şifre"
                        autoComplete="new-password"
                        error={errors.password}
                        inputRef={register({
                            required: "You must specify a password",
                            minLength: {
                                value: 8,
                                message: "Password must have at least 8 characters"
                            }
                        })}
                    />
                    <PasswordInput
                        name="password_confirmation"
                        label="Confirm Password"
                        autoComplete="new-password"
                        error={errors.password_confirmation}
                        inputRef={register({
                            validate: value =>
                                value === password.current || "The passwords do not match"
                        })}
                    />
            </form>
        </ColAtm>
        </>
    );

}

export default compose(withTranslation('common'), withStyles(styles, { withTheme: true })) (ResetPasswordForm);
